module.exports = __webpack_public_path__ + "img/avm.25db500a.svg";